<template>
  <div class="ele-body test-page">
    <el-card shadow="never" class="test-card" :body-style="{ padding: '0', height: '100%' }">
      <div class="test-shell">
        <aside class="api-aside">
          <div class="aside-title">接口目录</div>
          <div v-for="group in apiGroups" :key="group.name" class="aside-group">
            <div class="aside-group-name">{{ group.name }}</div>
            <div
              v-for="item in group.items"
              :key="item.key"
              class="aside-item"
              :class="{ active: activeApi === item.key }"
              @click="switchApi(item.key)">
              <span class="method-tag">POST</span>
              <span class="aside-item-name">{{ item.name }}</span>
            </div>
          </div>
        </aside>

        <div class="test-main">
          <div class="top-bar">
            <div class="top-left">
              <span class="method-tag">POST</span>
              <span class="api-name">{{ currentApi.name }}</span>
              <el-input :value="currentApi.path" size="small" readonly class="api-path" />
            </div>
            <div class="top-right">
              <el-button size="small" icon="el-icon-refresh" class="ele-btn-icon" :loading="channelLoading" @click="loadChannels">
                刷新
              </el-button>
              <el-button type="primary" size="small" :loading="submitting" @click="submit"
                v-if="permission.includes('sys:test:index')">开始</el-button>
            </div>
          </div>

          <div class="content-split">
            <section class="param-pane">
              <div class="pane-head">请求参数</div>
              <div class="pane-body">
                <div class="group-title">接入信息</div>
                <el-form label-width="90px" size="small" class="param-form">
                  <el-form-item label="测试商户">
                    <el-input :value="mchLabel" readonly />
                  </el-form-item>
                </el-form>

                <template v-if="showBizParams">
                  <div class="group-title">业务参数</div>
                  <el-form
                    v-if="activeApi === 'collection'"
                    ref="collectionForm"
                    :model="collectionForm"
                    :rules="collectionRules"
                    label-width="90px"
                    size="small"
                    class="param-form"
                    @submit.native.prevent>
                    <el-form-item label="通道类型">
                      <el-select
                        v-model="collectionType"
                        filterable
                        clearable
                        placeholder="请选择"
                        class="ele-block"
                        @change="collectionForm.channelId = ''">
                        <el-option v-for="item in collectionTypeList" :key="item" :label="item" :value="item" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="通道" prop="channelId">
                      <el-select
                        v-model="collectionForm.channelId"
                        filterable
                        clearable
                        placeholder="请选择"
                        class="ele-block"
                        :loading="channelLoading">
                        <el-option
                          v-for="item in filteredCollectionChannels"
                          :key="item.id"
                          :label="formatChannelLabel(item)"
                          :value="item.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="金额" prop="amount">
                      <el-input-number
                        v-model="collectionForm.amount"
                        :min="0.01"
                        :precision="2"
                        :step="100"
                        controls-position="right"
                        class="ele-fluid"
                        placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="备注">
                      <el-input v-model="collectionForm.remark" clearable placeholder="请输入" />
                    </el-form-item>
                  </el-form>

                  <el-form
                    v-else-if="activeApi === 'payment'"
                    ref="paymentForm"
                    :model="paymentForm"
                    :rules="paymentRules"
                    label-width="90px"
                    size="small"
                    class="param-form"
                    @submit.native.prevent>
                    <el-form-item label="通道类型">
                      <el-select
                        v-model="paymentType"
                        filterable
                        clearable
                        placeholder="请选择"
                        class="ele-block"
                        @change="paymentForm.channelId = ''">
                        <el-option v-for="item in paymentTypeList" :key="item" :label="item" :value="item" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="通道" prop="channelId">
                      <el-select
                        v-model="paymentForm.channelId"
                        filterable
                        clearable
                        placeholder="请选择"
                        class="ele-block"
                        :loading="channelLoading">
                        <el-option
                          v-for="item in filteredPaymentChannels"
                          :key="item.id"
                          :label="formatChannelLabel(item)"
                          :value="item.id" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="金额" prop="amount">
                      <el-input-number
                        v-model="paymentForm.amount"
                        :min="0.01"
                        :precision="2"
                        :step="100"
                        controls-position="right"
                        class="ele-fluid"
                        placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="收款账号" prop="account">
                      <el-input v-model="paymentForm.account" clearable placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="收款姓名" prop="accountName">
                      <el-input v-model="paymentForm.accountName" clearable placeholder="请输入" />
                    </el-form-item>
                    <el-form-item label="银行" prop="bankCode">
                      <el-select
                        v-model="paymentForm.bankCode"
                        filterable
                        clearable
                        placeholder="请选择"
                        class="ele-block">
                        <el-option
                          v-for="item in banks"
                          :key="item.bank_code"
                          :label="`${item.bank_name} (${item.bank_code})`"
                          :value="item.bank_code" />
                      </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                      <el-input v-model="paymentForm.remark" clearable placeholder="请输入" />
                    </el-form-item>
                  </el-form>

                  <el-form
                    v-else-if="isQueryApi"
                    ref="queryForm"
                    :model="queryForm"
                    :rules="queryRules"
                    label-width="90px"
                    size="small"
                    class="param-form"
                    @submit.native.prevent>
                    <el-form-item label="商户订单号" prop="merchantOrderNo">
                      <el-input v-model="queryForm.merchantOrderNo" clearable placeholder="请输入" />
                    </el-form-item>
                  </el-form>

                  <el-form
                    v-else-if="activeApi === 'upstreamBalance'"
                    ref="upstreamBalanceForm"
                    :model="upstreamBalanceForm"
                    :rules="upstreamBalanceRules"
                    label-width="90px"
                    size="small"
                    class="param-form"
                    @submit.native.prevent>
                    <el-form-item label="上游" prop="uplistId">
                      <el-select
                        v-model="upstreamBalanceForm.uplistId"
                        filterable
                        clearable
                        placeholder="请选择"
                        class="ele-block"
                        :loading="channelLoading">
                        <el-option
                          v-for="item in uplists"
                          :key="item.id"
                          :label="formatUplistLabel(item)"
                          :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-form>
                </template>
              </div>
            </section>

            <section class="result-pane">
              <div class="pane-head result-head">
                <span>调试结果</span>
                <div class="result-tabs">
                  <span
                    v-for="tab in resultTabs"
                    :key="tab.key"
                    class="result-tab"
                    :class="{ active: resultTab === tab.key }"
                    @click="resultTab = tab.key">
                    {{ tab.label }}
                  </span>
                </div>
              </div>
              <div class="result-code-wrap">
                <div class="result-code-actions">
                  <el-button type="text" size="mini" :disabled="!currentResultText" @click="copyCurrent">复制</el-button>
                </div>
                <pre class="result-code">{{ currentResultText || ' ' }}</pre>
              </div>
            </section>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatDebugValue } from '@/utils/debug-format';

const API_GROUPS = [
  {
    name: '支付接口',
    items: [
      { key: 'collection', name: '创建代收', path: '/SendTransaction/unifiedorder', api: '/Test/testCollection' },
      { key: 'payment', name: '创建代付', path: '/ReceiveCurrencyList/unifiedorder', api: '/Test/testPayment' }
    ]
  },
  {
    name: '查询接口',
    items: [
      { key: 'queryCollection', name: '代收查单', path: '/SendTransaction/queryTransaction', api: '/Test/testQueryCollection' },
      { key: 'queryPayment', name: '代付查单', path: '/ReceiveCurrencyList/queryTransaction', api: '/Test/testQueryPayment' },
      { key: 'balance', name: '余额查询', path: '/SendTransaction/getBalance', api: '/Test/testBalance' }
    ]
  },
  {
    name: '上游查询',
    items: [
      {
        key: 'upstreamQueryCollection',
        name: '上游代收查单',
        path: 'channel/query',
        api: '/Test/testUpstreamQueryCollection'
      },
      {
        key: 'upstreamQueryPayment',
        name: '上游代付查单',
        path: 'channel/query',
        api: '/Test/testUpstreamQueryPayment'
      },
      { key: 'upstreamBalance', name: '上游余额', path: 'channel/balance', api: '/Test/testUpstreamBalance' }
    ]
  }
];

const QUERY_APIS = ['queryCollection', 'queryPayment', 'upstreamQueryCollection', 'upstreamQueryPayment'];

const API_LIST = API_GROUPS.reduce((list, group) => list.concat(group.items), []);

const RESULT_TAB_DEFS = [
  { key: 'url', label: '请求地址' },
  { key: 'request', label: '请求报文' },
  { key: 'sign_plaintext', label: '签名明文' },
  { key: 'sign', label: 'sign' },
  { key: 'upstream_url', label: '上游地址' },
  { key: 'upstream_request', label: '上游请求' },
  { key: 'http_code', label: 'HTTP' },
  { key: 'response', label: '响应结果' },
  { key: 'merchant_response', label: '回商户' },
  { key: 'upstream_response', label: '上游返回' },
  { key: 'error', label: '异常问题' }
];

const RULE_SELECT = [{ required: true, message: '请选择', trigger: 'change' }];
const RULE_INPUT = [{ required: true, message: '请输入', trigger: 'blur' }];

function hasResultValue(value) {
  return value !== undefined && value !== null && value !== '';
}

export default {
  name: 'FrontpageTest',
  data() {
    return {
      apiGroups: API_GROUPS,
      activeApi: 'collection',
      resultTab: '',
      mchId: '',
      username: '',
      channelLoading: false,
      submitting: false,
      collectionType: '',
      paymentType: '',
      collectionChannels: [],
      paymentChannels: [],
      uplists: [],
      banks: [],
      collectionForm: {
        channelId: '',
        amount: undefined,
        remark: ''
      },
      paymentForm: {
        channelId: '',
        amount: undefined,
        account: '',
        accountName: '',
        bankCode: '',
        remark: ''
      },
      queryForm: {
        merchantOrderNo: ''
      },
      upstreamBalanceForm: {
        uplistId: ''
      },
      collectionRules: {
        channelId: RULE_SELECT,
        amount: RULE_INPUT
      },
      paymentRules: {
        channelId: RULE_SELECT,
        amount: RULE_INPUT,
        account: RULE_INPUT,
        accountName: RULE_INPUT,
        bankCode: RULE_SELECT
      },
      queryRules: {
        merchantOrderNo: RULE_INPUT
      },
      upstreamBalanceRules: {
        uplistId: RULE_SELECT
      },
      resultData: null,
      resultError: ''
    };
  },
  computed: {
    ...mapGetters(['permission']),
    currentApi() {
      return API_LIST.find((item) => item.key === this.activeApi) || API_LIST[0];
    },
    showBizParams() {
      return this.activeApi !== 'balance';
    },
    isQueryApi() {
      return QUERY_APIS.indexOf(this.activeApi) !== -1;
    },
    resultTabs() {
      const tabs = [];
      RESULT_TAB_DEFS.forEach((item) => {
        if (item.key === 'error') {
          if (this.resultError) {
            tabs.push(item);
          }
          return;
        }
        if (this.resultData && hasResultValue(this.resultData[item.key])) {
          tabs.push(item);
        }
      });
      return tabs;
    },
    mchLabel() {
      if (!this.mchId) {
        return '未加载';
      }
      return this.username ? `${this.username} (${this.mchId})` : this.mchId;
    },
    collectionTypeList() {
      return Array.from(new Set(this.collectionChannels.map((item) => item.channel_name).filter(Boolean)));
    },
    paymentTypeList() {
      return Array.from(new Set(this.paymentChannels.map((item) => item.channel_name).filter(Boolean)));
    },
    filteredCollectionChannels() {
      if (!this.collectionType) {
        return this.collectionChannels;
      }
      return this.collectionChannels.filter((item) => item.channel_name === this.collectionType);
    },
    filteredPaymentChannels() {
      if (!this.paymentType) {
        return this.paymentChannels;
      }
      return this.paymentChannels.filter((item) => item.channel_name === this.paymentType);
    },
    currentResultText() {
      if (!this.resultTab) {
        return '';
      }
      if (this.resultTab === 'error') {
        return this.resultError || '';
      }
      if (!this.resultData || !hasResultValue(this.resultData[this.resultTab])) {
        return '';
      }
      return formatDebugValue(this.resultData[this.resultTab]);
    }
  },
  watch: {
    resultTabs(tabs) {
      if (!tabs.length) {
        this.resultTab = '';
        return;
      }
      if (!tabs.some((item) => item.key === this.resultTab)) {
        this.resultTab = tabs[0].key;
      }
    }
  },
  mounted() {
    this.loadChannels();
  },
  methods: {
    formatChannelLabel(item) {
      const name = item.name || '';
      const code = item.channel_code || '';
      if (name && code) {
        return `${name} (${code})`;
      }
      return name || code || String(item.id);
    },
    formatUplistLabel(item) {
      const name = item.name || '';
      return name ? `${name} (${item.id})` : String(item.id);
    },
    findChannel(channels, channelId) {
      return channels.find((item) => item.id === channelId) || null;
    },
    switchApi(key) {
      if (this.activeApi === key) {
        return;
      }
      this.activeApi = key;
      this.resultData = null;
      this.resultError = '';
      this.resultTab = '';
    },
    copyCurrent() {
      const text = this.currentResultText;
      if (!text) {
        return;
      }
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.left = '-999999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message.success('已复制');
      } catch (e) {
        this.$message.error('复制失败');
      }
      document.body.removeChild(textarea);
    },
    loadChannels() {
      this.channelLoading = true;
      this.$http
        .get('/Test/getTestChannels')
        .then((res) => {
          this.channelLoading = false;
          if (res.data.code !== 0) {
            this.$message.error(res.data.msg || '加载失败');
            return;
          }
          const data = res.data.data || {};
          this.mchId = data.mch_id || '';
          this.username = data.username || '';
          this.collectionChannels = (data.collection || []).map((item) => ({
            ...item,
            id: Number(item.id)
          }));
          this.paymentChannels = (data.payment || []).map((item) => ({
            ...item,
            id: Number(item.id)
          }));
          this.uplists = (data.uplists || []).map((item) => ({
            ...item,
            id: Number(item.id)
          }));
          this.banks = data.banks || [];
        })
        .catch((e) => {
          this.channelLoading = false;
          this.$message.error(e.message);
        });
    },
    applyResult(res) {
      this.submitting = false;
      this.resultData = (res.data && res.data.data) || null;
      if (res.data.code !== 0) {
        this.resultError = res.data.msg || '请求失败';
        this.$message.warning(this.resultError);
        return;
      }
      this.$nextTick(() => {
        const prefer = this.resultTabs.find((item) => item.key === 'response') || this.resultTabs[0];
        this.resultTab = prefer ? prefer.key : '';
      });
    },
    postDebug(payload) {
      this.submitting = true;
      this.resultData = null;
      this.resultError = '';
      this.resultTab = '';
      this.$http
        .post(this.currentApi.api, payload)
        .then((res) => {
          this.applyResult(res);
        })
        .catch((e) => {
          this.submitting = false;
          this.resultError = e.message || '请求异常';
          this.$message.error(this.resultError);
        });
    },
    submit() {
      if (this.activeApi === 'balance') {
        this.postDebug({});
        return;
      }

      if (this.isQueryApi) {
        this.$refs.queryForm.validate((valid) => {
          if (!valid) {
            return;
          }
          this.postDebug({ MerchantOrderNo: this.queryForm.merchantOrderNo });
        });
        return;
      }

      if (this.activeApi === 'upstreamBalance') {
        this.$refs.upstreamBalanceForm.validate((valid) => {
          if (!valid) {
            return;
          }
          this.postDebug({ uplist_id: this.upstreamBalanceForm.uplistId });
        });
        return;
      }

      const isCollection = this.activeApi === 'collection';
      this.$refs[isCollection ? 'collectionForm' : 'paymentForm'].validate((valid) => {
        if (!valid) {
          return;
        }
        const form = isCollection ? this.collectionForm : this.paymentForm;
        const selected = this.findChannel(
          isCollection ? this.filteredCollectionChannels : this.filteredPaymentChannels,
          form.channelId
        );
        if (!selected) {
          this.$message.warning('请选择');
          return;
        }
        this.postDebug(
          isCollection
            ? {
                PaymentAmount: form.amount,
                Remark: form.remark,
                channel_code: selected.channel_code
              }
            : {
                PaymentAmount: form.amount,
                PayerAccount: form.account,
                PayerName: form.accountName,
                PayerBankName: form.bankCode,
                Remark: form.remark,
                channel_code: selected.channel_code
              }
        );
      });
    }
  }
};
</script>

<style scoped>
.test-page {
  height: calc(100vh - 100px);
  min-height: 560px;
}

.test-card {
  height: 100%;
}

.test-shell {
  display: flex;
  height: 100%;
  background: #fff;
}

.api-aside {
  width: 220px;
  flex-shrink: 0;
  border-right: 1px solid #ebeef5;
  background: #fafafa;
  overflow: auto;
}

.aside-title {
  padding: 14px 16px 10px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.aside-group-name {
  padding: 8px 16px;
  font-size: 12px;
  color: #909399;
}

.aside-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  cursor: pointer;
  color: #606266;
}

.aside-item:hover {
  background: #f0f7ff;
}

.aside-item.active {
  background: #ecf5ff;
  color: #409eff;
}

.aside-item-name {
  font-size: 13px;
}

.method-tag {
  display: inline-block;
  min-width: 40px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 3px;
  background: #ecf5ff;
  color: #409eff;
  font-size: 12px;
  font-weight: 600;
}

.test-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
}

.top-left {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.api-name {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.api-path {
  max-width: 420px;
}

.top-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.content-split {
  flex: 1;
  min-height: 0;
  display: flex;
}

.param-pane,
.result-pane {
  display: flex;
  flex-direction: column;
  min-width: 0;
  overflow: hidden;
}

.param-pane {
  flex: 1;
  border-right: 1px solid #ebeef5;
}

.result-pane {
  flex: 1;
}

.pane-head {
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
}

.result-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.result-tabs {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
  max-width: 75%;
}

.result-tab {
  padding: 4px 10px;
  font-size: 12px;
  color: #909399;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 400;
}

.result-tab.active {
  color: #409eff;
  background: #ecf5ff;
  font-weight: 600;
}

.pane-body {
  flex: 1;
  overflow: auto;
  padding: 12px 16px 20px;
}

.group-title {
  margin: 8px 0 12px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
  font-size: 13px;
  font-weight: 600;
  color: #606266;
}

.param-form {
  max-width: 520px;
}

.ele-fluid {
  width: 100%;
}

.result-code-wrap {
  position: relative;
  flex: 1;
  min-height: 0;
  margin: 12px 16px 16px;
  border-radius: 4px;
  background: #1e1e1e;
  overflow: hidden;
}

.result-code-actions {
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 1;
}

.result-code-actions .el-button {
  color: #c0c4cc;
}

.result-code {
  height: 100%;
  margin: 0;
  padding: 36px 16px 16px;
  overflow: auto;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  color: #d4d4d4;
  white-space: pre-wrap;
  word-break: break-all;
}

@media (max-width: 1100px) {
  .test-shell {
    flex-direction: column;
  }

  .api-aside {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #ebeef5;
  }

  .content-split {
    flex-direction: column;
  }

  .param-pane {
    border-right: none;
    border-bottom: 1px solid #ebeef5;
    max-height: 50%;
  }

  .result-code-wrap {
    min-height: 260px;
  }
}
</style>
